import { ErrorMessage } from "@hookform/error-message";
import React, { useEffect } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { validations } from "../Validations/regexValidations";

function HighRiskBankReferences() {
  const emptyFieldErrorMessage = "Campo obligatorio";
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();
  const { append, fields, prepend } = useFieldArray({
    control,
    name: "highRiskBankReferences",
  });

  useEffect(() => {
    !fields.length && prepend({});
  }, []);

  return (
    <React.Fragment>
      {fields.map((field, index) => {
        const baseName = `highRiskBankReferences[${index}]`;
        return (
				<div key={field.id} className="mt-6 create__requisitos">
					<h4 className="create__requisitos-title">Referencias bancarias</h4>
					<div className="lg:items-end lg:flex lg:space-x-9">
						<div className="mb-4 group-form lg:w-1/2">
							<label className="global-label">Nombre</label>
							<input
								type="text"
								maxLength={40}
								className="global-input"
								placeholder="Nombre"
								{...register(`${baseName}.Name`, {
									required: { value: true, message: emptyFieldErrorMessage },
									pattern: validations.letrasYespacios,
								})}
							/>
							<div className="h-6 w-full">
								<ErrorMessage
									errors={errors}
									name={`${baseName}.Name`}
									render={({ message }) => <p className="text-red-600 ml-1">{message}</p>}
								/>
							</div>
						</div>
						<div className="mb-4 group-form lg:w-1/2">
							<label className="global-label">Banco</label>
							<input
								type="text"
								maxLength={60}
								className="global-input"
								placeholder="Banco"
								{...register(`${baseName}.Bank`, {
									required: { value: true, message: emptyFieldErrorMessage },
									pattern: validations.letrasYespacios,
								})}
							/>
							<div className="h-6 w-full">
								<ErrorMessage
									errors={errors}
									name={`${baseName}.Bank`}
									render={({ message }) => <p className="text-red-600 ml-1">{message}</p>}
								/>
							</div>
						</div>
					</div>
					<div className="lg:items-end lg:flex lg:space-x-9">
						<div className="mb-4 group-form lg:w-1/2">
							<label className="global-label">Tipo de Cuenta</label>
							<input
								type="text"
								maxLength={60}
								className="global-input"
								placeholder="Tipo de Cuenta"
								{...register(`${baseName}.AccountType`, {
									required: { value: true, message: emptyFieldErrorMessage },
									pattern: validations.letrasYespacios,
								})}
							/>
							<div className="h-6 w-full">
								<ErrorMessage
									errors={errors}
									name={`${baseName}.AccountType`}
									render={({ message }) => <p className="text-red-600 ml-1">{message}</p>}
								/>
							</div>
						</div>
						<div className="mb-4 group-form lg:w-1/2">
							<label className="global-label">Número de Cuenta</label>
							<input
								type="text"
								maxLength={60}
								className="global-input"
								placeholder="Número de Cuenta"
								{...register(`${baseName}.AccountNumber`, {
									required: { value: true, message: emptyFieldErrorMessage },
									pattern: validations.letrasNumerosEspacios,
								})}
							/>
							<div className="h-6 w-full">
								<ErrorMessage
									errors={errors}
									name={`${baseName}.AccountNumber`}
									render={({ message }) => <p className="text-red-600 ml-1">{message}</p>}
								/>
							</div>
						</div>
					</div>
				</div>
			);
      })}
      <div className="mt-6 mb-6 text-center create__requisitos">
        <button
          type="button"
          onClick={() => {
            append({});
          }}
          className="mb-4"
        >
          <div className="mx-auto text-[#012169] opacity-50 text-[40px]">+</div>
          <span className="text-[#012169] opacity-50 font-bold mb-3">
            Agregar otra Referencia Bancaria
          </span>
        </button>
      </div>
    </React.Fragment>
  );
}

export default HighRiskBankReferences;
